import { useEffect, useState } from "react";

export const useLocalStorage = (key: string, defaultValue: boolean) => {
  const [state, setState] = useState(() => {
    try {
      const storedValue = localStorage.getItem(key);
      return storedValue === null ? defaultValue : storedValue === "true";
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      // persist the sound setting in local storage
      localStorage.setItem(key, JSON.stringify(state));
    } catch {
      // do nothing
    }
  }, [state, key]);

  return [state, setState] as const;
};
